module.exports = __webpack_public_path__ + "img/underwear_tightywhitey.5caba825.png";